angular.module('picmonicng').directive('tileAchievements', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/app/directives/tile-achievements/tile-achievements.html',
      controller: [
        '$scope',
        'User',
        function ($scope, User) {
          $scope.achievements = User.queryv3({ resource: 'achievements' });
        },
      ],
    };
  },
]);
